module.exports = __webpack_public_path__ + "img/roct.a2bb9b8c.png";